import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import HowItWorks from 'components/Shared/HowItWorks'

/**
 * Set campaign form with dropzone.
 * @Tags( simulation )
 * @Inputs( event name, date )
 */
const SimulationFormHeader = ({ accuracy }) => {
    const { t } = useTranslation()
    const progressStart = 5
    let pointerClass = ''
    if (accuracy > 33) { pointerClass = 'v2' }
    if (accuracy > 66) { pointerClass = 'v3' }

    useEffect(() => {
        const element = document.querySelector('.possibleAccuracy--sticky')
        const anchor = document.querySelector('.possibleAccuracy__anchor')
        const docBody = document.documentElement || document.body.parentNode || document.body
        const hasOffset = window.pageYOffset !== undefined
        let scrollTop = hasOffset ? window.pageYOffset : docBody.scrollTop
        if (anchor && (scrollTop > anchor.offsetTop)) {
            element.classList.add('active')
        }
        window.addEventListener('scroll', () => toggleStickyHeader(anchor, element, scrollTop, docBody, hasOffset))
    })

    const toggleStickyHeader = (anchor, element, scrollTop, docBody, hasOffset) => {
        scrollTop = hasOffset ? window.pageYOffset : docBody.scrollTop
        const anchorPosition = anchor.offsetTop
        if ((scrollTop < anchorPosition)) {
            element.classList.remove('active')
        } else {
            element.classList.add('active')
        }
    }

    const Accuracy = () => {
        return (
            <div className={`possibleAccuracy ${accuracy < progressStart ? 'disable' : ''}`}>
                <div className="card card-default m-0">
                    <div className="card-header d-none d-md-block">
                        <h2 className="card-title-default">{t('Simulation.possibleAccuracy')}</h2>
                    </div>
                    <div className="card-body p-4">

                        <div className="simulationProgressbar">
                            <svg className="simulationProgressbar__graph" viewBox="0 0 180 91" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M36.7389 17.4517C25.29 25.8569 15.9929 36.8523 9.60777 49.539C3.22261 62.2258 -0.069329 76.2436 0.00110674 90.4463L9.001 90.4017C8.9376 77.6192 11.9003 65.0032 17.647 53.5851C23.3936 42.1671 31.761 32.2712 42.065 24.7065L36.7389 17.4517Z" fill="#D63C24" />
                                <path d="M180 90C180 75.7971 176.639 61.7958 170.191 49.1409C163.743 36.4859 154.391 25.5367 142.901 17.1885L137.611 24.4696C147.952 31.9831 156.368 41.8373 162.172 53.2268C167.975 64.6162 171 77.2174 171 90H180Z" fill="#6CBDA2" />
                                <path d="M140.323 15.3835C125.392 5.31403 107.784 -0.0446693 89.7754 0.000280349C71.7667 0.04523 54.1856 5.49176 39.3055 15.6356L44.3749 23.072C57.767 13.9426 73.59 9.04071 89.7978 9.00025C106.006 8.9598 121.853 13.7826 135.29 22.8451L140.323 15.3835Z" fill="#F58562" />
                            </svg>
                            <div style={{ transform: `rotate(${(1.8 * accuracy) - 90}deg)` }} className={`simulationProgressbar__pointer ${pointerClass}`}></div>
                            <div className="simulationProgressbar__value">{accuracy < progressStart ? '-' : accuracy + '%'}</div>
                        </div>

                        {/* <div className="possibleAccuracy__summary">
              <div className="possibleAccuracy__summaryItem">
                <p>{t('Simulation.ticketsSold')}</p>
                <span>{accuracy < progressStart ? '-' : '2 423'}</span>
              </div>
              <div className="possibleAccuracy__summaryItem">
                <p>{t('Simulation.targetSize')}</p>
                <span>{accuracy < progressStart ? '-' : '4.8'}</span>
              </div>
            </div>*/}
                    </div>

                </div>
            </div>
        )
    }

    const instructionsList = [
        t('Simulation.description.1'),
        t('Simulation.description.2'),
        t('Simulation.description.3')
    ]

    return (
        <header className="simulation-form__header">
            <div className='pr-md-3 pb-md-0 pb-3 flex-grow-1'>
                <HowItWorks instructionsList={instructionsList} />
            </div>
            <Accuracy />
            <div className="d-md-none possibleAccuracy--sticky"><Accuracy /></div>
            <div className="possibleAccuracy__anchor"></div>
        </header>
    )
}

SimulationFormHeader.propTypes = {
    accuracy: PropTypes.string.isRequired
}

export default SimulationFormHeader